import React from 'react';
import ImagePickerField from './ImagePickerField';

const PackageForm = ({
  editingPackageId,
  handlePackageSubmit,
  newPackage,
  setNewPackage,
  handlePackageInputChange,
  currentServiceBs,
  setCurrentServiceBs,
  currentServiceEn,
  setCurrentServiceEn,
  addServiceToPackage,
  removeServiceFromPackage,
  setEditingPackageId
}) => {
  const autoResize = (e) => {
    e.target.style.height = 'auto';
    e.target.style.height = e.target.scrollHeight + 'px';
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <h3 className="text-lg font-semibold text-black mb-6">{editingPackageId ? 'Uredi paket' : 'Dodaj novi paket'}</h3>
      <form onSubmit={handlePackageSubmit} className="space-y-4">
        <div className="form-group">
          <label className="block text-sm font-medium text-black mb-1">Naziv Paketa (BS)</label>
          <div style={{ position: 'relative' }}>
            <textarea
              name="naziv.bs"
              rows="1"
              value={newPackage.naziv?.bs || (typeof newPackage.naziv === 'string' ? newPackage.naziv : '')}
              onChange={(e) => { handlePackageInputChange(e); autoResize(e); }}
              required
              placeholder="npr. Premium Paket"
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
            />
          </div>
        </div>
        <div className="form-group">
          <label className="block text-sm font-medium text-black mb-1">Naziv Paketa (EN)</label>
          <textarea
            name="naziv.en"
            rows="1"
            value={newPackage.naziv?.en || ''}
            onChange={(e) => { handlePackageInputChange(e); autoResize(e); }}
            placeholder="e.g. Premium Package"
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
          />
        </div>

        <div className="form-group">
          <label className="block text-sm font-medium text-black mb-1">Opis (BS)</label>
          <div style={{ position: 'relative' }}>
            <textarea
              name="opis.bs"
              rows="1"
              value={newPackage.opis?.bs || (typeof newPackage.opis === 'string' ? newPackage.opis : '')}
              onChange={(e) => { handlePackageInputChange(e); autoResize(e); }}
              placeholder="Opis..."
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
            />
          </div>
        </div>
        <div className="form-group">
          <label className="block text-sm font-medium text-black mb-1">Opis (EN)</label>
          <textarea
            name="opis.en"
            rows="1"
            value={newPackage.opis?.en || ''}
            onChange={(e) => { handlePackageInputChange(e); autoResize(e); }}
            placeholder="Description..."
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
          />
        </div>

        <div className="flex gap-4">
          <div className="form-group flex-1">
            <label className="block text-sm font-medium text-black mb-1">Trajanje (BS)</label>
            <div style={{ position: 'relative' }}>
              <input 
                name="trajanje.bs" 
                value={newPackage.trajanje?.bs || ''} 
                onChange={handlePackageInputChange} 
                placeholder="npr. 10 sati" 
                className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
              />
            </div>
          </div>
          <div className="form-group flex-1">
            <label className="block text-sm font-medium text-black mb-1">Trajanje (EN)</label>
            <input 
              name="trajanje.en" 
              value={newPackage.trajanje?.en || ''} 
              onChange={handlePackageInputChange} 
              placeholder="e.g. 10 hours" 
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
            />
          </div>
        </div>

        <div className="flex gap-4">
          <div className="form-group flex-[2]">
            <label className="block text-sm font-medium text-black mb-1">Cijena</label>
            <input 
              name="cijena" 
              value={newPackage.cijena} 
              onChange={handlePackageInputChange} 
              required 
              placeholder="npr. 1500" 
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
            />
          </div>
          <div className="form-group flex-1">
            <label className="block text-sm font-medium text-black mb-1">Valuta</label>
            <select 
              name="valuta" 
              value={newPackage.valuta} 
              onChange={handlePackageInputChange}
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
            >
              <option value="BAM">BAM</option>
              <option value="EUR">EUR</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label className="block text-sm font-medium text-black mb-1">Usluge / Stavke (BS | EN)</label>
          <div className="flex flex-col gap-2">
            <div style={{ position: 'relative' }}>
              <textarea
                rows="1"
                value={currentServiceBs}
                onChange={(e) => { setCurrentServiceBs(e.target.value); autoResize(e); }}
                onKeyDown={addServiceToPackage}
                placeholder="Stavka na bosanskom..."
                className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
              />
            </div>
            <textarea
              rows="1"
              value={currentServiceEn}
              onChange={(e) => { setCurrentServiceEn(e.target.value); autoResize(e); }}
              onKeyDown={addServiceToPackage}
              placeholder="Item in English..."
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm p-3 border"
            />
            <button type="button" onClick={(e) => addServiceToPackage(e)} className="w-full bg-gray-100 text-black py-2 rounded-lg font-medium hover:bg-gray-200 transition-all text-sm">+ Dodaj stavku</button>
          </div>
          <ul className="mt-3 space-y-2">
            {newPackage.usluge && newPackage.usluge.map((service, index) => (
              <li key={index} className="flex justify-between items-center bg-gray-50 px-3 py-2 rounded-lg text-sm group">
                <span className="text-black">{typeof service === 'object' ? `${service.bs} / ${service.en || ''}` : service}</span>
                <span onClick={() => removeServiceFromPackage(index)} className="text-black hover:text-red-500 cursor-pointer font-bold px-2">×</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
          <input
            type="checkbox"
            id="prikaziNaNaslovnojPkg"
            name="prikaziNaNaslovnoj"
            checked={newPackage.prikaziNaNaslovnoj}
            onChange={handlePackageInputChange}
            className="w-4 h-4 rounded border-gray-300 text-black focus:ring-black"
          />
          <label htmlFor="prikaziNaNaslovnojPkg" className="text-sm font-medium text-black cursor-pointer">
            Prikaži ovaj paket na naslovnoj stranici?
          </label>
        </div>

        <div className="form-group pb-6 border-b border-gray-100">
          <ImagePickerField 
            label="Slika Paketa"
            value={newPackage.slika}
            onSelect={(path) => setNewPackage(prev => ({ ...prev, slika: path }))}
          />
        </div>

        <div className="flex gap-3 pt-4">
          <button type="submit" className="flex-[3] bg-black text-white hover:bg-gray-800 py-3 rounded-lg font-bold transition-colors shadow-sm text-[10px] uppercase tracking-[0.2em]">
            {editingPackageId ? 'Spremi izmjene' : 'Dodaj paket'}
          </button>
          <button
            type="button"
            onClick={() => {
              setEditingPackageId(null);
              setNewPackage({
                naziv: { bs: '', en: '' }, opis: { bs: '', en: '' }, cijena: '', valuta: 'BAM', usluge: [], slika: '', prikaziNaNaslovnoj: false
              });
            }}
            className="flex-1 py-3 border border-gray-300 text-black rounded-lg font-bold hover:bg-gray-50 transition-colors text-[10px] uppercase tracking-[0.2em]"
          >
            Otkaži
          </button>
        </div>
      </form>
    </div>
  );
};

export default PackageForm;